import { render } from "./TopCategories.vue?vue&type=template&id=50d19104&scoped=true"
import script from "./TopCategories.vue?vue&type=script&lang=js"
export * from "./TopCategories.vue?vue&type=script&lang=js"

import "./TopCategories.vue?vue&type=style&index=0&id=50d19104&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d19104"]])

export default __exports__